import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { FormControl, FormGroup } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class CertRequestsService {
  private http = inject(HttpClient);
  private token: string = sessionStorage.getItem('token') as string;

  formFilterList = new FormGroup({
    name: new FormControl(''),
    data: new FormControl(''),
    page: new FormControl(0),
    size: new FormControl(15),
  });

  createCertRequest(body: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
    };

    return this.http
      .patch<any>(`${environment.api}/cert-requests/send`,
        body,
        httpOptions
      )
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  saveProgressCertRequest(body: any, frontUrl: string): Observable<any> {
    let params = new HttpParams;
    params = params.set('frontUrl', frontUrl);

    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
      params
    };

    return this.http
      .post<any>(
        `${environment.api}/cert-requests`,
        body,
        httpOptions
      )
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  changeCertRequestStatus(id: string, status: 'WRITING' | 'PENDING' | 'REFUSED' | 'APPROVED' | 'PENDING_INTERACTION' | 'PENDING_APPROVAL'): Observable<any> {
    const params = new HttpParams().set('frontUrl', environment.frontUrl).set('status', status);

    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
      params,
    };

    return this.http.patch<any>(`${environment.api}/cert-requests/${id}`, {}, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        throw error;
      })
    );
  }

  listCertRequest(payload: {
    size: number;
    page: number;
    name?: string;
    status?: string;
    date?: string;
  }) {
    let params = new HttpParams()
      .set('size', payload.size)
      .set('page', payload.page);

    if (payload.status) {
      params = params.set('status', payload.status);
    }

    if (payload.name) {
      params = params.set('nameApplicant', payload.name);
    }

    if (payload.date) {
      params = params.set('requestDate', payload.date);
    }

    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
      params,
    };

    return this.http.get<any>(`${environment.api}/cert-requests/list-filtered`, httpOptions).pipe(map((response: any) => response),
      catchError((error: HttpErrorResponse) => {
        throw error;
      })
    );
  }

  userRegister(body: any) {
    const params = new HttpParams()
      .set('frontUrl', 'qima.agrotransparencia.com.br')

    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
      params
    };

    return this.http.post<any>(`${environment.api}/cert-requests/user/register`, body, httpOptions);
  }

  //Update (durante o preenchimento:
  // PUT:
  // /cert-requests
  // body com o json
  updateCertRequest(payload: any, id: string, frontUrl: string) {
    let params = new HttpParams;
    params = params.set('frontUrl', frontUrl);
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.token,
      }),
      params
    };

    return this.http.put<any>(`${environment.api}/cert-requests/${id}`, payload, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: HttpErrorResponse) => {
        throw error;
      })
    );
  }

  getUserCertRequestById(id: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
    };

    return this.http
      .get<any>(
        `${environment.api}/cert-requests/${id}`,
        httpOptions
      )
      .pipe(
        map((response: any) => response),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  getUserCertRequestByUserId(userId: string, frontUrl: string) {
    // Busca unica:
    // GET:
    // /cert-requests/user/{userId}
    // (só passar o userId como pathVariable)
    let params = new HttpParams;
    params = params.set('frontUrl', frontUrl);

    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
      params
    };

    return this.http.get<any>(`${environment.api}/cert-requests/user/${userId}`, httpOptions)
      .pipe(
        map((response: any) => response),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  getUserCertRequestByCustomerId(customerId: string) {
    let params = new HttpParams;
    params = params.set('customerId', customerId);
    const httpOptions = {
      params
    };

    return this.http.get<any>(`${environment.api}/cert-requests/get-by-customer`, httpOptions)
  }

  updateCertRequestStatus(formId: string, status: string) {
    //     Atualizar status:
    // PATCH:
    // /cert-requests/{id}/status
    // Passar o id como pathVariable e o novo status como requestParam
    // Os status possíveis são
    //         WRITING, PENDING, REFUSED, APPROVED, PENDING_INTERACTION, PENDING_APPROVAL

    const params = new HttpParams()
      .set('status', status)
    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
      params,
    };
    return this.http
      .patch<any>(
        `${environment.api}/cert-requests/${formId}/status`,
        httpOptions
      )
      .pipe(
        map((response: any) => response),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  sendMessageCertRequest(message: any, requestNumber: string) {
    const body = {
      requestNumber: requestNumber,
      message: message,
    };
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: sessionStorage.getItem('token') as string,
      }),
    };
    return this.http
      .post<any>(
        `${environment.api}/cert-requests/send-message`, message,
        httpOptions
      )
      .pipe(
        map((response: any) => response),
        catchError((error: HttpErrorResponse) => {
          throw error;
        })
      );
  }

  sendArchiveCertRequest(payload: {
    formId: string;
    proposalPath: string;
    requestName: string;
    requestDate: string;
    requestVersion: string;
  }) {
    // Enviar proposta (usuário qima subir o arquivo)
    // Aqui o usuário vai carregar o arquivo, você vai usar a rota padrão de upload e subir o base64 que retorna na rota abaixo
    // PATCH
    // /cert-requests/{id}/proposal
    // Requestparam com nome proposalPath e valor = base64
    const params = new HttpParams()
      .set('proposalPath', payload.proposalPath)
      .set('requestName', payload.requestName)
      .set('requestVersion', payload.requestVersion)
      .set('requestDate', payload.requestDate)
      .set('link', environment.frontUrl)
      .set('status', 'PENDING_APPROVAL');
    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.token,
      }),
      params
    };
    return this.http.patch<any>(`${environment.api}/cert-requests/${payload.formId}/proposal`, {}, httpOptions).pipe(
      map((response: any) => response),
      catchError((error: HttpErrorResponse) => {
        throw error;
      })
    );
  }
}
